<template>
<div :class="['odr-tab-navigation__header--item', { 'odr-tab-navigation__header--item-selected': isActiveHeader }]"
     @click="selectTab">
    <slot></slot>
    <span v-if="counterNumber" class="odr-tab-navigation__header--size">{{formatCounter(counterNumber)}}</span>
</div>
</template>

<script>
import { tabBus } from '@/utils/tab-bus';
import { mapGetters } from 'vuex';

export default {
    inject: ['acknowledgementMandatory'],
    props: {
        counter: {
            type: String,
            default: null,
        },
        max: {
            type: String,
            default: null,
        },
        index: {
            type: String,
            default: null,
        },
    },
    data () {
        return {
            isActiveHeader: false,
            counterNumber: +this.counter,
        };
    },
    mounted () {
        tabBus.$on('tab-change', this.updateActiveState);
    },
    beforeDestroy () {
        tabBus.$off('tab-change', this.updateActiveState);
    },
    methods: {
        updateActiveState (activeIndex) {
            this.isActiveHeader = this.index === activeIndex;
        },
        selectTab () {
            const acknowledgementMandatory = this.getAcknowledgement(this.acknowledgementMandatory);
            const require = acknowledgementMandatory.require;
            const acknowledged = acknowledgementMandatory.acknowledged;
            if (!acknowledgementMandatory || acknowledged || !require) {
                tabBus.$emit('tab-change', this.index);
            } else if (require && !acknowledged) {
                this.$store.commit('flow/SET_ACKNOWLEDGEMENT_ERROR', {
                    acknowledgement: acknowledgementMandatory,
                    showError: true,
                });
            }
        },
        formatCounter (counter) {
            const maxNumber = +this.max || 10;
            if (counter > maxNumber) {
                return `${maxNumber}+`;
            }
            return counter;
        },
    },
    computed: {
        ...mapGetters('flow', {
            getAcknowledgement: 'getAcknowledgement',
        }),
    },
};
</script>
